import script from "./vizOccupationDuSol.vue?vue&type=script&setup=true&lang=js"
export * from "./vizOccupationDuSol.vue?vue&type=script&setup=true&lang=js"

import "./vizOccupationDuSol.vue?vue&type=style&index=0&id=d2a35378&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2a35378"]])

export default __exports__